import React from 'react';

export const NegativeInvIcon = ({
    width = 20,
    height = 20,
    bgFill = 'gray',
    fgFill = '#FFF'
}: {
    width?: number;
    height?: number;
    bgFill?: string;
    fgFill?: string;
}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <circle fill={bgFill} cx="10" cy="10" r="10" />
            <path
                d="m6.696 5.647.084.073L10 8.939l3.22-3.22a.75.75 0 0 1 1.133.977l-.073.084L11.061 10l3.22 3.22a.75.75 0 0 1-.977 1.133l-.084-.073L10 11.061l-3.22 3.22a.75.75 0 0 1-1.133-.977l.073-.084L8.939 10l-3.22-3.22a.75.75 0 0 1 .977-1.133z"
                fill={fgFill}
            />
        </g>
    </svg>
);
